import { Component, inject, Input, OnChanges, ViewEncapsulation } from '@angular/core';

import { MarkdownUtility, RenderType } from '@shared/utils/markdown.utility';
import { AiChatNavigationService } from '../../ai-chat-navigation.service';

@Component({
  selector: 'app-ai-chat-markdown-view',
  template: ` <div [innerHTML]="convertedData" (click)="onContentClick($event)"></div> `,
  styleUrls: ['./ai-chat-markdown-view.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
})
export class AiChatMarkdownViewComponent implements OnChanges {
  @Input() public value: string;

  private readonly aiChatNavigationService: AiChatNavigationService = inject(AiChatNavigationService);

  public convertedData: string;

  public ngOnChanges(): void {
    this.convertedData = MarkdownUtility.render(this.value || '', RenderType.AICHAT);
  }

  public onContentClick(event: MouseEvent): void {
    const anchor = (event.target as Element).closest('a');
    if (!anchor) {
      return;
    }
    const href = anchor.getAttribute('href');
    if (href && this.aiChatNavigationService.navigateTo(href)) {
      event.preventDefault();
    }
  }
}
